import React, { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";
import { useAppContext } from "../context/AppContext";

const UploadHistory = () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [role, setRole] = useState(null);

  const axiosAPI = useAxios();
  const { state } = useAppContext();

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  const buildQuery = (currentPage) => {
    const params = new URLSearchParams();
    params.append("page", currentPage);
    return params.toString();
  };

  async function fetchData() {
    setLoading(true);
    const queryString = buildQuery(page);

    try {
      const res = await axiosAPI.get(
        `/api/history/get-history-data?${queryString}`,
      );
      setData(res.data.results);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      console.error("Error fetching history:", err);
    } finally {
      setLoading(false);
    }
  }

  const handleDownloadFile = async (fileUrl, fileName) => {
    console.log("file url and file name", fileUrl, fileName);
    if (!fileUrl) {
      if (window.notifyMessage) {
        window.notifyMessage(
          "Warning",
          "File URL not available for this record.",
          "warning",
        );
      } else {
        alert("File URL not available for this record.");
      }
      return;
    }
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName || "file.xlsx");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Direct download failed, opening in new tab:", error);
      window.open(fileUrl, "_blank");
    }
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      await axiosAPI.delete(`/api/history/delete-history/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchData();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  useEffect(() => {
    setRole(state?.user?.role);
  }, [state]);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-end flex-wrap gap-3">
                <h4 className="card-title mb-0">
                  All History ({data?.length || 0})
                </h4>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>BATCH_ID</th>
                        <th>FILE NAME</th>
                        <th>UPLOAD DATE</th>
                        <th>TABLE NAME</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : data.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        data.map((item) => {
                          const formattedDateTime = new Date(
                            item.upload_date,
                          ).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                            timeZone: "Asia/Kolkata",
                          });

                          return (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.file_name}</td>
                              <td>{formattedDateTime}</td>
                              <td>{item.table_name}</td>
                              <td>
                                {item.file_url ? (
                                  <button
                                    className="btn btn-icon btn-round btn-primary btn-sm me-2"
                                    title="View / Download File"
                                    onClick={() =>
                                      handleDownloadFile(
                                        item.file_url,
                                        item.file_name,
                                      )
                                    }
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-icon btn-round btn-secondary btn-sm me-2"
                                    title="No file available"
                                    disabled
                                  >
                                    <i className="fas fa-eye-slash"></i>
                                  </button>
                                )}
                                {/* {role === "admin" && (
                                  <button
                                    className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                    onClick={() => handleDelete(item.id)}
                                    title="Delete"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                )} */}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <nav aria-label="Page navigation">
              <ul className="pagination flex justify-content-end">
                {/* First Page */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    First
                  </button>
                </li>

                {/* Previous */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page - 1)}
                  >
                    Previous
                  </button>
                </li>

                {/* Page Number Buttons in chunks */}
                {(() => {
                  const pageNumbers = [];
                  const maxPagesToShow = 5;
                  const startPage =
                    Math.floor((page - 1) / maxPagesToShow) * maxPagesToShow +
                    1;
                  const endPage = Math.min(
                    startPage + maxPagesToShow - 1,
                    totalPages,
                  );

                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <li
                        key={i}
                        className={`page-item ${page === i ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(i)}
                        >
                          {i}
                        </button>
                      </li>,
                    );
                  }
                  return pageNumbers;
                })()}

                {/* Next */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page + 1)}
                  >
                    Next
                  </button>
                </li>

                {/* Last Page */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadHistory;
